import { Dialog } from '@headlessui/react';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useTranslation from '../../../../../hooks/useTranslations';
import { closeEvaluationFinalizeModal, saveEvaluation, openEvaluationFinalizeModal, selectActiveBusinessArea, selectActiveEvalAppCategory, selectActiveEvalAppFolder, selectActiveEvaluationId, selectActiveForm, selectActiveFormValues, selectEvaluationFinalizeModalIsOpen, createEvaluation } from '../../../../../redux/modules/evaluationsSlice';
import ModalWrapper from '../../../layouts/partials/ModalWrapper';

const FinalizeEvaluationModal = () => {
	const t = useTranslation();
	const dispatch = useDispatch();

	const isEvaluationModalOpen = useSelector((state) => (selectEvaluationFinalizeModalIsOpen(state)));
	const activeEvaluationId = useSelector((state) => (selectActiveEvaluationId(state)));
	const activeBusinessArea = useSelector((state) => (selectActiveBusinessArea(state)));
	const activeEvalAppCategory = useSelector((state) => (selectActiveEvalAppCategory(state)));
	const activeEvalAppFolder = useSelector((state) => (selectActiveEvalAppFolder(state)));
	const activeForm = useSelector((state) => (selectActiveForm(state)));
	const activeFormValues = useSelector((state) => (selectActiveFormValues(state)));

	const setIsModalOpen = useCallback((shouldOpen) => {
		if (shouldOpen) {
			dispatch(openEvaluationFinalizeModal());
		} else {
			dispatch(closeEvaluationFinalizeModal());
		}
	}, [dispatch]);

	const finalize = () => {
		if (activeEvaluationId && activeForm && activeFormValues) {
			dispatch(saveEvaluation({
				evaluationId: activeEvaluationId, form: activeForm, formValues: activeFormValues, finalized: true, t,
			}));
		} else if (activeBusinessArea && activeEvalAppCategory && activeEvalAppFolder && activeForm && activeFormValues) {
			dispatch(createEvaluation({
				businessArea: activeBusinessArea, evalAppCategory: activeEvalAppCategory, evalAppFolder: activeEvalAppFolder, form: activeForm, formValues: activeFormValues, finalized: true, t,
			}));
		}
		setIsModalOpen(false);
	};

	return (
		<ModalWrapper isModalOpen={isEvaluationModalOpen} setIsModalOpen={setIsModalOpen} maxWidth="max-w-sm">
			<Dialog.Title
				as="h3"
				className="text-[1.25rem] font-semibold text-oly-gray-darkest text-center mb-4"
			>
				{t('eval_app_form_finalize_alert_title')}
			</Dialog.Title>
			<Dialog.Description
				as="p"
				className="text-[1.0625rem] text-oly-gray-darkest text-center mb-8 leading-6"
			>
				{t('eval_app_form_finalize_alert_message')}
			</Dialog.Description>
			<div className="flex -mx-6 border-t divide-x border-oly-gray-lightest divide-oly-gray-lightest">
				<button
					type="button"
					className="text-left flex-1 h-16 inline-flex justify-center items-center flex-grow px-4 py-2 text-[0.9375rem] font-normal text-oly-blue-dark can-hover:hover:bg-oly-gray-lightestAlpha45 focus-visible:bg-oly-gray-lightestAlpha45 focus:outline-none"
					onClick={() => setIsModalOpen(false)}
				>
					{t('bookmarks_remove_cancel')}
				</button>
				<button
					type="button"
					className="text-left flex-1 h-16 inline-flex justify-center items-center flex-grow px-4 py-2 text-[0.9375rem] font-semibold text-oly-blue-dark can-hover:hover:bg-oly-gray-lightestAlpha45 focus-visible:bg-oly-gray-lightestAlpha45 focus:outline-none disabled:text-oly-gray-normal disabled:!bg-white disabled:cursor-not-allowed disabled:opacity-75"
					onClick={() => finalize()}
				>
					{t('eval_app_form_finalize')}
				</button>
			</div>
		</ModalWrapper>
	);
};

export default FinalizeEvaluationModal;
